import React from "react";
import { NAV_KEPSEK } from "@/lib/nav";
import { BukuDigitalReadonlyList, BukuDigitalReader } from "@/pages/pustaka/BukuDigitalShared";

export function BukuDigitalKepsek() {
  return <BukuDigitalReadonlyList nav={NAV_KEPSEK} basePath="/kepsek/buku/digital" title="Daftar Buku Digital" />;
}

export function BacaBukuDigitalKepsek() {
  return <BukuDigitalReader nav={NAV_KEPSEK} backPath="/kepsek/buku/digital" />;
}
